import Autopay from 'features/payOverTime/screens/Autopay/Autopay';
import React from 'react';

export default function Page() {
  return <Autopay />;
}
